import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { api } from "../services/apiService";
import type from "../actions/types";
import { isApiFailure } from "./apiFailure";

function* fetchQlink(action) {
    try {
        const qLinkRes = yield call(
            api.fetchQlinkUrl,
            action.payload
        );

        // fetchQlinkUrl is doGetCall-backed: a failure resolves {status, errMsg},
        // never errStatus — the old errStatus-only guard dispatched SUCCESS on
        // failure (#603 gate finding 5). publish/revoke below are doUpdateCall
        // (errStatus) and correct as-is.
        if (isApiFailure(qLinkRes)) {
            yield put({
                type: type.QLINK_FETCH_ERROR,
                status: qLinkRes?.errMsg?.error,
            });
        } else {
            yield put({
                type: type.QLINK_FETCH_SUCCESS,
                qlinkObj: qLinkRes
            });
        }
    } catch (e) {
        yield put({
            type: type.QLINK_FETCH_ERROR,
            message: e.message
        });
    }
}

function* publishQlink(action) {
    try {
        const publishRes = yield call(
            api.publishQlinkUrl,
            action.payload
        );

        if (publishRes.errStatus) {
            yield put({
                type: type.QLINK_PUBLISH_ERROR,
                status: publishRes?.errMsg?.error,
            });
        } else {
            yield put({
                type: type.QLINK_PUBLISH_SUCCESS,
                publishedQlinkObj: publishRes
            });
        }
    } catch (e) {
        yield put({
            type: type.QLINK_PUBLISH_ERROR,
            message: e.message
        });
    }
}

function* revokeQlink(action) {
    try {
        const revokeLinkRes = yield call(
            api.revokeQlinkUrl,
            action.payload
        );


        if (revokeLinkRes.errStatus) {
            yield put({
                type: type.QLINK_REVOKE_ERROR,
                status: revokeLinkRes?.errMsg?.error,
            });
        } else {
            yield put({
                type: type.QLINK_REVOKE_SUCCESS,
                revokedQlinkObj: revokeLinkRes
            });
        }
    } catch (e) {
        yield put({
            type: type.QLINK_REVOKE_ERROR,
            message: e.message
        });
    }
}

// Test seam: fetchQlink failure classification (the api layer never rejects).
export const testable = { fetchQlink };

function* watchFetchQlink() {
    yield takeEvery(type.QLINK_FETCH_REQUEST, fetchQlink);
}

function* watchPublishQlink() {
    yield takeEvery(type.QLINK_PUBLISH_REQUEST, publishQlink);
}

function* watchRevokeQlink() {
    yield takeEvery(type.QLINK_REVOKE_REQUEST, revokeQlink);
}


export default function* qLinkSaga() {
    yield all([
        fork(watchFetchQlink),
        fork(watchPublishQlink),
        fork(watchRevokeQlink)
    ]);
}